import {jsx as _jsx} from "react/jsx-runtime";import DOMPurify from 'dompurify'
import {twMerge} from 'tailwind-merge'
import getSafeRegex from '~/utils/getSafeRegex'








const TypeAheadLabel = (props) => {
  const {query, label, highlight, className} = props
  const queryHtml = highlight ? `<mark className="bg-sky-300">$&</mark>` : `<b>$&</b>`
  const cleanInnerHtml = DOMPurify.sanitize(
    query ? label.replace(getSafeRegex(query, 'gi'), queryHtml) : label
  )
  return (
    _jsx('span', {
      className: twMerge('overflow-hidden text-ellipsis whitespace-nowrap', className),
      dangerouslySetInnerHTML: {
        __html: cleanInnerHtml
      },}
    )
  )
}

export default TypeAheadLabel
